import { Component } from '@angular/core';

@Component({
  selector: 'app-threepr-contact',
  templateUrl: './threepr-contact.component.html',
  styleUrls: ['./threepr-contact.component.scss']
})
export class ThreeprContactComponent {
  email3PR = '3CE@eqhf.pbz';
}
